var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wizard-base',{staticClass:"procedure",attrs:{"title":_vm.$t('WIZARD.PROCEDURE.TITLE')}},[_c('property-address'),_c('ProcedureItems',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }